module.exports = __webpack_public_path__ + "img/4.47c42b68.png";